import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import BackButton from "../components/BackButton";
import { useAuth } from "../context/AuthContext";

export default function GrowPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { technique, fromAppreciation } = location.state || {};
  const { isAuthenticated, logout } = useAuth();
  const [showAccountDropdown, setShowAccountDropdown] = useState(false);

  // Handle clicking outside dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAccountDropdown && !event.target.closest('.account-dropdown')) {
        setShowAccountDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAccountDropdown]);

  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-amber-100 to-amber-200 p-6">
      <div className="flex justify-between items-center mb-6">
        <BackButton />
        <div className="flex gap-3">
          <button
            onClick={() => navigate('/')}
            className="bg-white/80 backdrop-blur-sm border border-amber-400 text-amber-700 font-medium px-4 py-2 rounded-full shadow hover:bg-amber-100 transition"
          >
            Artist Corner
          </button>
          {isAuthenticated ? (
            <div className="flex gap-3">
              <button
                onClick={() => navigate('/artist-wall')}
                className="bg-white/80 backdrop-blur-sm border border-amber-400 text-amber-700 font-medium px-4 py-2 rounded-full shadow hover:bg-amber-100 transition"
              >
                My Gallery
              </button>
              <button
                onClick={handleSignOut}
                className="bg-white/80 backdrop-blur-sm border border-amber-400 text-amber-700 font-medium px-4 py-2 rounded-full shadow hover:bg-amber-100 transition"
              >
                Sign Out
              </button>
            </div>
          ) : (
            <div className="flex gap-3">
              <button
                onClick={() => navigate('/login')}
                className="bg-white/80 backdrop-blur-sm border border-amber-400 text-amber-700 font-medium px-4 py-2 rounded-full shadow hover:bg-amber-100 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate('/signup')}
                className="bg-white/80 backdrop-blur-sm border border-amber-400 text-amber-700 font-medium px-4 py-2 rounded-full shadow hover:bg-amber-100 transition"
              >
                Join Community
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white/80 backdrop-blur-sm border-2 border-amber-200 rounded-2xl p-6 shadow-lg"
        >
          <h1 className="text-3xl font-bold text-amber-800 mb-4">🌱 Grow with Artmosphere</h1>
          
          <div className="space-y-6">
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-200">
              <h2 className="text-2xl font-semibold text-amber-700 mb-4">Coming Soon: Art Courses!</h2>
              <p className="text-gray-700 mb-4">
                We're working on exciting art courses to help you learn and grow as an artist. Soon you'll be able to:
              </p>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center gap-2">
                  <span className="text-amber-600">Create</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-amber-600">Share</span>
                </li>
                <li className="flex items-center gap-2">
                  <span className="text-amber-600">Grow</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-r from-amber-100 to-amber-200 p-6 rounded-lg border border-amber-300">
              <h2 className="text-xl font-semibold text-amber-800 mb-3">Stay Tuned!</h2>
              <p className="text-gray-700">
                We're putting the finishing touches on our courses. Check back soon for updates and be among the first to join our art learning community!
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
